module.exports = __webpack_public_path__ + "img/michaela-pro.78b91be8.jpg";